/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "model.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

/* tslint:disable */
import { Motive } from './motive.model';


export class Authorisation {
    code: string; // ecf001
    name: string; // ecf001
    helpText: string; // ecf001
    needsAmount: boolean; // ecf001
    hasMotives: boolean; // ecf001
    motives?: Motive[]; // ecf001


    // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template &quot;model-json.velocity&quot;
 */

    /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

    public static mergeJSON(instance: any, data: any): Authorisation {
        if (!data) { return instance; }
        if (data.code != null) {instance.code = data.code; }
        if (data.name != null) {instance.name = data.name; }
        if (data.helpText != null) {instance.helpText = data.helpText; }
        if (data.needsAmount != null) {instance.needsAmount = data.needsAmount; }
        if (data.hasMotives != null) {instance.hasMotives = data.hasMotives; }
        if (data.motives != null) {
            instance.motives = [];
            ([].concat(data.motives)).forEach(occurrence => {
                instance.motives.push(new Motive().fromJSON(occurrence)); // i3
            });
        }
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return Authorisation.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: Authorisation) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return Authorisation.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: Authorisation): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }

    /** ---- */


/** end of template &quot;model-json.velocity&quot; */

    // </editor-fold>

}


/** end of template "model.velocity" */
